<div class="payment_explanation" @click="onExplanationClick($event)">
    <template v-for="item in explanation.items" :key="item.orderItemId">
        <div class="payment_explanation_item" v-if="item.summary || item.details.length > 0">
            <p class="payment_explanation_summary" v-if="item.summary" v-html="renderPart(item.summary)"></p>
            <ul class="payment_explanation_details" v-if="item.details.length > 0">
                <li v-for="(detail, index) in item.details" :key="index" v-html="renderPart(detail)"></li>
            </ul>
        </div>
    </template>

    <p class="payment_explanation_total" v-if="explanation.totalCalculation" v-html="renderPart(explanation.totalCalculation)"></p>

    <p class="payment_explanation_date" v-if="explanation.dateExplanation" v-html="renderPart(explanation.dateExplanation)"></p>

    <div class="payment_explanation_diagnostics" v-if="explanation.diagnostics && explanation.diagnostics.length > 0">
        <h4 class="payment_explanation_diagnostics_header">{{ $t('order.diagnostics.header') }}</h4>
        <ul>
            <li v-for="(part, index) in explanation.diagnostics" :key="index" v-html="renderPart(part)"></li>
        </ul>
    </div>
</div>
